export default __webpack_public_path__ + "static/media/microsoft-powerpoint.808adb03.svg";